import { Card } from "../ui/card";
import { Skeleton } from "../ui/skeleton";

interface AccordianSkeletonProps {}

export function AccordianSkeleton({}: AccordianSkeletonProps) {
  return (
    <Card className="py-3 border-none shadow-none">
      <div className="space-y-4">
        {Array.from({ length: 6 }).map((_, index) => (
          <div key={index}>
            {/* Parent Skeleton */}
            <Skeleton className="h-12 w-full border BookEZ_card_border_color BookEZ_card_bg p-4 space-y-2" />
          </div>
        ))}
      </div>
    </Card>
  );
}
